<template>
  <el-dialog :visible.sync="dialog" :close-on-click-modal="false">
    <el-card :body-style="{ padding: '0px' }">
      <img :src="image" class="image">
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save()">OK</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "TagDigitalImage",
  methods: {
    open(image) {
      const vm = this;
      vm.image = image;
      vm.dialog = true;
    },
    save() {
      const vm = this;
      vm.dialog = false;
    },
  },
  data() {
    return {
      dialog: false,
      image: null,
    };
  },
};
</script>
